import { HudButton } from 'components/HudButton'
import { PlusIcon } from 'lucide-react'
import React, { Dispatch, FC, SetStateAction } from 'react'

interface MapPlusButtonProps {
  isSelected: boolean
  setIsSelected: Dispatch<SetStateAction<boolean>>
}

export const MapPlusButton: FC<MapPlusButtonProps> = (props) => {
  return (
    <HudButton
      icon={<PlusIcon />}
      isSelected={props.isSelected}
      onClick={() => props.setIsSelected(!props.isSelected)}
      animation='scale'
      scaleAmount={1.1}
      iconSize='80%'
    />
  )
}
